var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 234 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 113.032C.227 48.582 52.525 0 117 0c64.484 0 116.787 48.594 117 113.057v.382l-2.467 117.889-95.039 98.676V168.118l55.592-12.985 16.297-36.199-91.139 19.248h-.36l-90.755-19.248 15.428 36.186 54.67 12.985v161.873L2.07 231.302 0 113.439V113.032Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m154.012 5.583-14.703 42.492h21.043l-18.49 43.264 47.157-52.127h-21.48l10.942-22.808a116.316 116.316 0 0 0-24.469-10.821Z",
    fill: "url(#logo-head_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-head_svg__a",
    x1: 166.897,
    y1: 3.484,
    x2: 162.688,
    y2: 84.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e85134079b3d9de295148890a051b62.svg";
export { ForwardRef as ReactComponent };